module.exports = __webpack_public_path__ + "img/blockables-instructions-1.4e07af12.png";